export const TUTORIAL_TOGGLE_TUTORIAL_MODAL = 'TUTORIAL_TOGGLE_TUTORIAL_MODAL';
export const TUTORIAL_LOAD_ALL_VIDEOS_BEGIN = 'TUTORIAL_LOAD_ALL_VIDEOS_BEGIN';
export const TUTORIAL_LOAD_ALL_VIDEOS_SUCCESS = 'TUTORIAL_LOAD_ALL_VIDEOS_SUCCESS';
export const TUTORIAL_LOAD_ALL_VIDEOS_FAILURE = 'TUTORIAL_LOAD_ALL_VIDEOS_FAILURE';
export const TUTORIAL_LOAD_ALL_VIDEOS_DISMISS_ERROR = 'TUTORIAL_LOAD_ALL_VIDEOS_DISMISS_ERROR';
